import { useEffect, useState } from 'react'
import { useActiveSectionsTop } from 'weblite-router'
import { VisibilityHandler } from '$scenes/components/visibility-handler'
import { ViewStory } from '$comp/_app/components/story/view-story'

export function Story() {
  const [isTop, setIsTop] = useState(false)

  const activeSection = useActiveSectionsTop()

  useEffect(() => {
    setIsTop(activeSection === 'story')
  }, [activeSection])

  if (!isTop) return null
  return (
    <VisibilityHandler
      zIndex={3}
      considerIOSNotch
      style={{ position: 'fixed' }}
    >
      <ViewStory isOpen={isTop} />
    </VisibilityHandler>
  )
}
